import { render, staticRenderFns } from "./UserPerformancePanel.vue?vue&type=template&id=26b68736&scoped=true&"
import script from "./UserPerformancePanel.vue?vue&type=script&lang=js&"
export * from "./UserPerformancePanel.vue?vue&type=script&lang=js&"
import style0 from "./UserPerformancePanel.vue?vue&type=style&index=0&id=26b68736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b68736",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VDivider,VIcon,VNavigationDrawer,VSkeletonLoader})
